<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" xl="10" lg="10" md="12" sm="12">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-monitor-edit</v-icon>
              <span class="headline font-weight-bold">Editar Painel</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-6">
              <v-form ref="form" v-model="valid" @submit.prevent="submit">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="login"
                      label="Login"
                      disabled
                      outlined
                      prepend-icon="mdi-account"
                      class="mb-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="nome"
                      label="Identificação"
                      outlined
                      :rules="nameRules"
                      prepend-icon="mdi-identifier"
                      class="mb-4"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="idLocalEscolhido"
                      :items="listaLocais"
                      item-value="idLocal"
                      item-text="nomeLocal"
                      label="Local"
                      outlined
                      :rules="[v => !!v || 'Selecione um local']"
                      prepend-icon="mdi-map-marker"
                      required
                      class="mb-4"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="objectVideoEscolhido"
                      :items="listaVideos"
                      item-value="idVideo"
                      item-text="nome"
                      label="Vídeo"
                      outlined
                      :rules="[v => !!v || 'Selecione um vídeo']"
                      prepend-icon="mdi-video"
                      return-object
                      required
                      class="mb-4"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete
                      v-model="mAnuncios"
                      :items="anuncios"
                      item-value="idAnuncio"
                      item-text="nome"
                      label="Anúncios"
                      outlined
                      multiple
                      chips
                      prepend-icon="mdi-advertisements"
                      class="mb-4"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-radio-group
                      v-model="modoVisualizacao"
                      :rules="[v => !!v || 'Campo obrigatório']"
                      class="mb-4"
                    >
                      <template v-slot:label>
                        <div class="font-weight-bold">Quais chamadas você deseja mostrar?</div>
                      </template>
                      <v-radio value="recepcao" label="Recepção"></v-radio>
                      <v-radio value="medico" label="Médico"></v-radio>
                      <v-radio value="recepcao-medico" label="Recepção e Médico"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-checkbox
                      v-model="checkboxSenha"
                      label="Deseja alterar a senha?"
                      class="mt-0 mb-2"
                    ></v-checkbox>
                    <v-text-field
                      v-model="senha"
                      :disabled="!checkboxSenha"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="showPassword ? 'text' : 'password'"
                      label="Nova senha"
                      outlined
                      :rules="checkboxSenha ? senhaRules : []"
                      counter
                      @click:append="showPassword = !showPassword"
                      class="mb-4"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-checkbox
                      v-model="isTelevisao"
                      :true-value="1"
                      :false-value="0"
                      label="Exibir transmissão de canais no painel?"
                      class="mt-0"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="12">
                    <v-slider
                      v-model="volume"
                      thumb-label="always"
                      prepend-icon="mdi-volume-low"
                      append-icon="mdi-volume-high"
                      min="0"
                      max="100"
                      label="Volume"
                      class="mb-4"
                    ></v-slider>
                  </v-col>
                </v-row>

                <v-alert
                  v-model="erroLogin"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Username já está em uso!
                </v-alert>

                <v-alert
                  v-model="sucessoLogin"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Painel atualizado com sucesso!
                </v-alert>
              </v-form>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                large
                outlined
                color="grey darken-1"
                :to="{ path: '/listaPaineisUnidade' }"
                class="mr-3"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn
                color="primary"
                large
                depressed
                :disabled="!valid || loading"
                :loading="loading"
                @click="submit"
                class="px-6"
              >
                <v-icon left>mdi-content-save</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'EditarPainelUnidade',
  data () {
    return {
      showPassword: false,
      loading: false,
      valid: false,
      isTelevisao: 0,
      anuncios: [],
      mAnuncios: [],
      tipo: 6,
      login: '',
      idLocalEscolhido: '',
      objectVideoEscolhido: null,
      modoVisualizacao: '',
      idVideoEscolhido: '',
      erroLogin: false,
      sucessoLogin: false,
      senha: '',
      volume: 50,
      listaLocais: [],
      listaVideos: [],
      nameRules: [
        v => !!v || 'Identificação é obrigatória',
        v => (v && v.length >= 6) || 'Identificação deve ter pelo menos 6 caracteres'
      ],
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 5) || 'Senha deve ter pelo menos 5 caracteres'
      ],
      checkboxSenha: false
    }
  },
  async mounted () {
    if (!this.$route.params.item) {
      this.$router.push('/listaPaineisUnidade')
      return
    }

    this.user = this.$store.getters.usuario
    await Promise.all([
      this.retornarAnuncios(),
      this.retornarLocais(),
      this.retornarVideos()
    ])

    this.loadPanelData(this.$route.params.item)
  },
  methods: {
    async retornarAnuncios () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarAnuncios()
        if (response.status === 200) {
          this.anuncios = response.data
        }
      } catch (error) {
        console.error('Erro ao buscar anúncios:', error)
      }
    },
    async retornarLocais () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarLocais(this.user.idEmpresa)
        this.listaLocais = response.data || []
      } catch (error) {
        console.error('Erro ao buscar locais:', error)
      }
    },
    async retornarVideos () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarVideos()
        this.listaVideos = response.data || []
      } catch (error) {
        console.error('Erro ao buscar vídeos:', error)
      }
    },
    loadPanelData (panel) {
      this.login = panel.username
      this.nome = panel.nome
      this.idLocalEscolhido = panel.idLocal
      this.idVideoEscolhido = panel.idVideo
      this.modoVisualizacao = panel.modoVisualizacao
      this.isTelevisao = panel.isTelevisao || 0
      this.volume = panel.volume || 50

      if (panel.idAnuncios) {
        this.organizarAnuncios(panel.idAnuncios)
      }

      this.objectVideoEscolhido = this.listaVideos.find(v => v.idVideo === this.idVideoEscolhido)
    },
    organizarAnuncios (anunciosString) {
      const ids = anunciosString.split(',')
      this.mAnuncios = ids.map(id => parseInt(id)).filter(id => !isNaN(id))
    },
    async submit () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.erroLogin = false
      this.sucessoLogin = false

      try {
        const anunciosParaAtualizar = this.prepareAnunciosData()
        const senhaParaEnviar = this.checkboxSenha ? this.senha : ''

        const response = await administradorUnidadeService.administradorUnidade.alterarFuncionario(
          this.idLocalEscolhido,
          this.nome,
          this.tipo,
          this.login,
          senhaParaEnviar,
          this.isTelevisao,
          this.volume,
          this.objectVideoEscolhido,
          this.modoVisualizacao,
          anunciosParaAtualizar,
          this.$route.params.item.idFuncionario
        )

        if (response.data === 'usernameExistente') {
          this.erroLogin = true
          return
        }

        if (response.data === true) {
          this.sucessoLogin = true
          setTimeout(() => {
            this.$router.push('/listaPaineisUnidade')
          }, 1500)
        }
      } catch (error) {
        console.error('Erro ao atualizar painel:', error)
        this.erroLogin = true
      } finally {
        this.loading = false
      }
    },
    prepareAnunciosData () {
      return this.anuncios.map(anuncio => ({
        idAnuncio: anuncio.idAnuncio,
        status: this.mAnuncios.includes(anuncio.idAnuncio) ? 1 : 0
      })).sort((a, b) => b.status - a.status)
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>
